
export default {
  props: {
    image: Object,
    size: String,
    _class: String,
    alt: String,
    width: Number,
    height: Number,
    fullSizeUrl: String,
    notLazy: { type: Boolean, default: false },
    withSpinner: { type: Boolean, default: false }
  },
  computed: {
    imageSrc () {
      return this.fullSizeUrl || this.image.small.webp
    }
  }
}
